import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/student/my-exams`;

export const myExamsRoutesObj = {
  list: baseRoute,
  view: `${baseRoute}/view/:courseId`,
  showOnline: `${baseRoute}/:courseId/:examId/show-online-exam/`,
  startOnlineMultipleChoice: `${baseRoute}/:courseId/:examId/:attemptId/start-online-exam/multiple/`,
  startOnlineBinary: `${baseRoute}/:courseId/:examId/:attemptId/start-online-exam/true-false/`,
  showDescriptive: `${baseRoute}/:courseId/:examId/show-descriptive-exam/`,
  startDescriptive: `${baseRoute}/:courseId/:examId/:attemptId/start-descriptive-exam/`,
  submitResultDescriptive: `${baseRoute}/:courseId/:examId/:attemptId/submit-descriptive-exam/`,
  submitResultOnline: `${baseRoute}/:courseId/:examId/:attemptId/submit-online-exam/`,
  showOnlineExamScore: `${baseRoute}/:courseId/:examId/:attemptId/online-exam/score/`,
  checkOnlineExamScore: `${baseRoute}/:courseId/:examId/:attemptId/online-exam/score/answers/check`,
  checkOnlineExamQuestionDescription: `${baseRoute}/:courseId/:examId/:attemptId/online-exam/score/answers/check/description/:questionId`,
  showDescriptiveExamScore: `${baseRoute}/:courseId/:examId/:attemptId/descriptive-exam/score/`,
} as const;

export type IMyExamsRouteParams = IExtractRouteParamMap<
  typeof myExamsRoutesObj
>;

export const myExamsPath = createPaths<
  typeof myExamsRoutesObj,
  IMyExamsRouteParams
>(myExamsRoutesObj);
